import type { NotifLang } from '@/types/admin.types';

export const LANG_OPTIONS: Array<{ id: NotifLang; flag: string; label: string }> = [
  { id: 'es', flag: '🇲🇽', label: 'Español'   },
  { id: 'en', flag: '🇺🇸', label: 'Inglés'    },
  { id: 'pt', flag: '🇧🇷', label: 'Portugués' },
  { id: 'fr', flag: '🇫🇷', label: 'Francés'   },
  { id: 'de', flag: '🇩🇪', label: 'Alemán'    },
  { id: 'nl', flag: '🇳🇱', label: 'Holandés'  },
  { id: 'ro', flag: '🇷🇴', label: 'Rumano'    },
];

interface LangBarProps { active: NotifLang; onSwitch: (l: NotifLang) => void; group: string; }

export function LangBar({ active, onSwitch, group }: LangBarProps) {
  return (
    <div className="notif-lang-bar">
      {LANG_OPTIONS.map(l => (
        <button key={l.id} className={`notif-lang-btn${active === l.id ? ' active' : ''}`}
          onClick={() => onSwitch(l.id)} data-group={group}>
          {l.flag} {l.label}
        </button>
      ))}
    </div>
  );
}
